import { apiAxios as authAxios } from '../axios.config';

export const listQualificationLevels = () => {
    return authAxios.get('/api/qualificationLevel');
}